/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import { ExecutionResult } from 'graphql';
import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type LoyaltyProfileDataFragment = {
  readonly __typename?: 'LoyaltyProfile';
  readonly customerId: string;
  readonly joinDate: any;
  readonly hasPaidTierHistory: boolean;
  readonly tierStatus: {
    readonly __typename?: 'TierStatus';
    readonly id: string;
    readonly name: Types.TierStatusName;
  } | null;
  readonly trialEligible: ReadonlyArray<{
    readonly __typename?: 'TrialEligibility';
    readonly duration: number;
    readonly durationUnit: Types.DurationUnit;
  }> | null;
  readonly tier: {
    readonly __typename?: 'Tier';
    readonly id: string;
    readonly name: Types.TierName;
    readonly nextTier: {
      readonly __typename?: 'Tier';
      readonly id: string;
      readonly name: Types.TierName;
    } | null;
  } | null;
};

export type SubscriptionCreditCardFragmentFragment = {
  readonly __typename?: 'SubscriptionCreditCard';
  readonly id: string;
  readonly cardType: Types.BraintreeCardType;
  readonly lastFour: string;
  readonly expirationMonth: string | null;
  readonly expirationYear: string | null;
  readonly isActive: boolean;
};

export type PaymentSubscriptionProfileDataFragment = {
  readonly __typename?: 'PaymentSubscriptionProfile';
  readonly id: string;
  readonly creditCards: ReadonlyArray<{
    readonly __typename?: 'SubscriptionCreditCard';
    readonly id: string;
    readonly cardType: Types.BraintreeCardType;
    readonly lastFour: string;
    readonly expirationMonth: string | null;
    readonly expirationYear: string | null;
    readonly isActive: boolean;
  }> | null;
};

export type PaymentSubscriptionProfileWithExpirationStateFragment = {
  readonly __typename?: 'PaymentSubscriptionProfile';
  readonly id: string;
  readonly creditCards: ReadonlyArray<{
    readonly __typename?: 'SubscriptionCreditCard';
    readonly expirationState: Types.CardExpirationState;
    readonly id: string;
    readonly cardType: Types.BraintreeCardType;
    readonly lastFour: string;
    readonly expirationMonth: string | null;
    readonly expirationYear: string | null;
    readonly isActive: boolean;
  }> | null;
};

export type SweetpassMembershipQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type SweetpassMembershipQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename?: 'LoyaltyProfile';
    readonly customerId: string;
    readonly joinDate: any;
    readonly hasPaidTierHistory: boolean;
    readonly tierStatus: {
      readonly __typename?: 'TierStatus';
      readonly id: string;
      readonly name: Types.TierStatusName;
    } | null;
    readonly trialEligible: ReadonlyArray<{
      readonly __typename?: 'TrialEligibility';
      readonly duration: number;
      readonly durationUnit: Types.DurationUnit;
    }> | null;
    readonly tier: {
      readonly __typename?: 'Tier';
      readonly id: string;
      readonly name: Types.TierName;
      readonly nextTier: {
        readonly __typename?: 'Tier';
        readonly id: string;
        readonly name: Types.TierName;
      } | null;
    } | null;
  } | null;
  readonly getSubscriptions: ReadonlyArray<{
    readonly __typename?: 'PaymentSubscription';
    readonly id: string;
    readonly status: Types.PaymentSubscriptionStatus;
    readonly paidThroughDate: any | null;
    readonly nextBillingDate: string;
    readonly nextBillingPeriodAmount: string;
    readonly firstBillingDate: any | null;
    readonly billingFrequencyUnit: Types.DurationUnit | null;
    readonly price: string | null;
  }>;
  readonly paymentSubscriptionProfile: {
    readonly __typename?: 'PaymentSubscriptionProfile';
    readonly id: string;
    readonly creditCards: ReadonlyArray<{
      readonly __typename?: 'SubscriptionCreditCard';
      readonly id: string;
      readonly cardType: Types.BraintreeCardType;
      readonly lastFour: string;
      readonly expirationMonth: string | null;
      readonly expirationYear: string | null;
      readonly isActive: boolean;
    }> | null;
  } | null;
};

export type SweetpassMembershipWithExpirationStateQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type SweetpassMembershipWithExpirationStateQuery = {
  readonly __typename?: 'Query';
  readonly loyaltyProfile: {
    readonly __typename?: 'LoyaltyProfile';
    readonly customerId: string;
    readonly joinDate: any;
    readonly hasPaidTierHistory: boolean;
    readonly tierStatus: {
      readonly __typename?: 'TierStatus';
      readonly id: string;
      readonly name: Types.TierStatusName;
    } | null;
    readonly trialEligible: ReadonlyArray<{
      readonly __typename?: 'TrialEligibility';
      readonly duration: number;
      readonly durationUnit: Types.DurationUnit;
    }> | null;
    readonly tier: {
      readonly __typename?: 'Tier';
      readonly id: string;
      readonly name: Types.TierName;
      readonly nextTier: {
        readonly __typename?: 'Tier';
        readonly id: string;
        readonly name: Types.TierName;
      } | null;
    } | null;
  } | null;
  readonly getSubscriptions: ReadonlyArray<{
    readonly __typename?: 'PaymentSubscription';
    readonly id: string;
    readonly status: Types.PaymentSubscriptionStatus;
    readonly paidThroughDate: any | null;
    readonly nextBillingDate: string;
    readonly nextBillingPeriodAmount: string;
    readonly firstBillingDate: any | null;
    readonly billingFrequencyUnit: Types.DurationUnit | null;
    readonly price: string | null;
  }>;
  readonly paymentSubscriptionProfile: {
    readonly __typename?: 'PaymentSubscriptionProfile';
    readonly id: string;
    readonly creditCards: ReadonlyArray<{
      readonly __typename?: 'SubscriptionCreditCard';
      readonly expirationState: Types.CardExpirationState;
      readonly id: string;
      readonly cardType: Types.BraintreeCardType;
      readonly lastFour: string;
      readonly expirationMonth: string | null;
      readonly expirationYear: string | null;
      readonly isActive: boolean;
    }> | null;
  } | null;
};

export const sweetpassMembershipQueryMock: ExecutionResult<SweetpassMembershipQuery> =
  {
    data: {
      loyaltyProfile: {
        customerId: 'e509e6ea-9fee-442a-9962-587ce7190430',
        joinDate: 'DateTime',
        hasPaidTierHistory: true,
        tierStatus: {
          id: 'da7a7163-ba7e-4da9-ae8a-185e3da00a9a',
          name: 'ACTIVE',
        },
        trialEligible: [{ duration: -2, durationUnit: 'DAY' }],
        tier: {
          id: '534319d0-8060-4b59-aa25-0f9c4016b1bd',
          name: 'OPTED_OUT',
          nextTier: {
            id: '634cb273-b7f9-4f18-9030-f1b1f2c49f5f',
            name: 'OPTED_OUT',
          },
        },
      },
      getSubscriptions: [
        {
          id: '7994ccdc-ab38-4b74-85af-be88532ede7a',
          status: 'Active',
          paidThroughDate: 'DateTime',
          nextBillingDate: 'Hello World',
          nextBillingPeriodAmount: 'Hello World',
          firstBillingDate: 'DateTime',
          billingFrequencyUnit: 'DAY',
          price: 'Hello World',
        },
        {
          id: '1daa933e-0e09-45a7-b48f-0bb560d0180d',
          status: 'Active',
          paidThroughDate: 'DateTime',
          nextBillingDate: 'Hello World',
          nextBillingPeriodAmount: 'Hello World',
          firstBillingDate: 'DateTime',
          billingFrequencyUnit: 'DAY',
          price: 'Hello World',
        },
        {
          id: '39ca0c05-20a3-452a-8a65-41b5bc5d089f',
          status: 'Active',
          paidThroughDate: 'DateTime',
          nextBillingDate: 'Hello World',
          nextBillingPeriodAmount: 'Hello World',
          firstBillingDate: 'DateTime',
          billingFrequencyUnit: 'DAY',
          price: 'Hello World',
        },
      ],
      paymentSubscriptionProfile: {
        id: '52e921d9-1bfd-4fba-bd38-fdf8eb150587',
        creditCards: [
          {
            id: '384c4829-9be5-411f-9b1e-39b6d74afbe5',
            cardType: 'AmEx',
            lastFour: 'Hello World',
            expirationMonth: 'Hello World',
            expirationYear: 'Hello World',
            isActive: false,
          },
          {
            id: 'f8a3a6f3-2f0e-4dae-b122-810af291521b',
            cardType: 'AmEx',
            lastFour: 'Hello World',
            expirationMonth: 'Hello World',
            expirationYear: 'Hello World',
            isActive: false,
          },
          {
            id: '7f2badd9-c8f9-46f0-90ca-15396429788b',
            cardType: 'AmEx',
            lastFour: 'Hello World',
            expirationMonth: 'Hello World',
            expirationYear: 'Hello World',
            isActive: false,
          },
        ],
      },
    },
  };

export const sweetpassMembershipWithExpirationStateQueryMock: ExecutionResult<SweetpassMembershipWithExpirationStateQuery> =
  {
    data: {
      loyaltyProfile: {
        customerId: '94138d50-0493-44e0-80ad-7fd62514dd94',
        joinDate: 'DateTime',
        hasPaidTierHistory: true,
        tierStatus: {
          id: '36b41c23-d4c4-4b96-8aa8-622a517d3cbc',
          name: 'ACTIVE',
        },
        trialEligible: [{ duration: 97, durationUnit: 'DAY' }],
        tier: {
          id: '05167a35-8d45-41b9-b136-63db9eb2f517',
          name: 'OPTED_OUT',
          nextTier: {
            id: 'f534a27f-5acf-4bda-83bf-af7e27a59a38',
            name: 'OPTED_OUT',
          },
        },
      },
      getSubscriptions: [
        {
          id: 'e64855fe-3c24-470d-9f38-aff27422c629',
          status: 'Active',
          paidThroughDate: 'DateTime',
          nextBillingDate: 'Hello World',
          nextBillingPeriodAmount: 'Hello World',
          firstBillingDate: 'DateTime',
          billingFrequencyUnit: 'DAY',
          price: 'Hello World',
        },
      ],
      paymentSubscriptionProfile: {
        id: '33169f0c-ff6a-4934-bd88-d8eee30f22b9',
        creditCards: [
          {
            id: '4d253ab9-4c40-4130-b664-c55f9f516095',
            cardType: 'AmEx',
            lastFour: 'Hello World',
            expirationMonth: 'Hello World',
            expirationYear: 'Hello World',
            isActive: true,
            expirationState: 'EXPIRED',
          },
        ],
      },
    },
  };
export const LoyaltyProfileDataFragmentDoc = gql`
  fragment LoyaltyProfileData on LoyaltyProfile {
    customerId
    joinDate
    hasPaidTierHistory
    tierStatus {
      id
      name
    }
    trialEligible {
      duration
      durationUnit
    }
    tier {
      id
      name
      nextTier {
        id
        name
      }
    }
  }
`;
export const SubscriptionCreditCardFragmentFragmentDoc = gql`
  fragment SubscriptionCreditCardFragment on SubscriptionCreditCard {
    id
    cardType
    lastFour
    expirationMonth
    expirationYear
    isActive
  }
`;
export const PaymentSubscriptionProfileDataFragmentDoc = gql`
  fragment PaymentSubscriptionProfileData on PaymentSubscriptionProfile {
    id
    creditCards {
      ...SubscriptionCreditCardFragment
    }
  }
  ${SubscriptionCreditCardFragmentFragmentDoc}
`;
export const PaymentSubscriptionProfileWithExpirationStateFragmentDoc = gql`
  fragment PaymentSubscriptionProfileWithExpirationState on PaymentSubscriptionProfile {
    id
    creditCards {
      ...SubscriptionCreditCardFragment
      expirationState
    }
  }
  ${SubscriptionCreditCardFragmentFragmentDoc}
`;
export const SweetpassMembershipDocument = gql`
  query SweetpassMembership {
    loyaltyProfile {
      ...LoyaltyProfileData
    }
    getSubscriptions(status: [ACTIVE, PAST_DUE]) {
      id
      status
      paidThroughDate
      nextBillingDate
      nextBillingPeriodAmount
      firstBillingDate
      billingFrequencyUnit
      price
    }
    paymentSubscriptionProfile {
      ...PaymentSubscriptionProfileData
    }
  }
  ${LoyaltyProfileDataFragmentDoc}
  ${PaymentSubscriptionProfileDataFragmentDoc}
`;

export function useSweetpassMembershipQuery(
  options?: Omit<Urql.UseQueryArgs<SweetpassMembershipQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    SweetpassMembershipQuery,
    SweetpassMembershipQueryVariables
  >({ query: SweetpassMembershipDocument, ...options });
}
export const SweetpassMembershipWithExpirationStateDocument = gql`
  query SweetpassMembershipWithExpirationState {
    loyaltyProfile {
      ...LoyaltyProfileData
    }
    getSubscriptions(status: [ACTIVE, PAST_DUE]) {
      id
      status
      paidThroughDate
      nextBillingDate
      nextBillingPeriodAmount
      firstBillingDate
      billingFrequencyUnit
      price
    }
    paymentSubscriptionProfile {
      ...PaymentSubscriptionProfileWithExpirationState
    }
  }
  ${LoyaltyProfileDataFragmentDoc}
  ${PaymentSubscriptionProfileWithExpirationStateFragmentDoc}
`;

export function useSweetpassMembershipWithExpirationStateQuery(
  options?: Omit<
    Urql.UseQueryArgs<SweetpassMembershipWithExpirationStateQueryVariables>,
    'query'
  >,
) {
  return Urql.useQuery<
    SweetpassMembershipWithExpirationStateQuery,
    SweetpassMembershipWithExpirationStateQueryVariables
  >({ query: SweetpassMembershipWithExpirationStateDocument, ...options });
}
